loadjs.ready(['jquery', 'core'], function() {
    $body.on('click', '.shipping-change-location', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if ($body.data('locationChangeLoaded')) {
            $('#shipping-change-location-modal').modal('show')
            return false;
        }

        preloader(1);
        $.get(routes.shipping.change, function(r) {
            var $r = $(r);
            var $form = $r.filter('form');
            $r.find('.icon').icon();
            $form.formValidate();
            $form.on('success', function(e, r) {
                $('#shipping-change-location-modal').modal('hide')
                $body.trigger('locationChanged', r);
            });
            $body.append($r);
            $body.data('locationChangeLoaded', 1);
            preloader(0);
            $('#shipping-change-location-modal').modal('show')
        })
        return false;
    })
})